module.exports = __webpack_public_path__ + "static/media/winsor-newton.8cf00ae9.png";